import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { DetailedDiolog } from "./DetailedDialog";

export function Receivable() {
    return (
        <>
            <PageHeader />
            <DataBox />
            <DetailedDiolog />
        </>
    );
}

